import GroupOrderReview from './GroupOrderReview'

export default GroupOrderReview
